import { gql } from 'graphql-request';

export default gql`
  mutation stripeCustomerMutate($data: JSON) {
    stripeCustomerMutate(data: $data) {
      success
      message
      data
    }
  }
`;
